<template>
  <div class="floating-toolbelt-wrapper">
    <template>
      <div id="localStreamContainer" />
      <div id="remoteStreamContainer" />
    </template>
    <div class="presentation-toolbelt" @touchmove.prevent>
      <div :class="audienceListCls">
        <span
          v-for="(audience, idx) in displayMemberList"
          :key="'memberAvatar' + idx"
          class="member-avatar"
          :class="{
            'member-avatar-presenter': audience.userID === hostUserId,
          }"
          :style="{ backgroundImage: `url(${audience.avatar})` }"
        />
      </div>
      <div v-if="amAlone" class="waiting-reminder">
        {{ aloneReminderText }}
      </div>
      <template v-else>
        <template v-if="!isReplay">
          <div
            v-show="!isHost"
            class="request-control-btn"
            data-stat-id="control"
            @click="requestPresenterControl"
          >
            我要控制
          </div>
          <div class="timer-and-end-btn" @click="confirmToQuit">
            <div class="timer">
              {{ elapseTime | formatTimer }}
            </div>
            <div>结束</div>
          </div>
        </template>
      </template>
      <div v-if="isInRoom" v-show="bubbleText" class="message-bubble">
        <div class="bubble-text">
          {{ bubbleText }}
        </div>
        <div class="bubble-tip" />
      </div>
    </div>
  </div>
</template>
<script>
import QS from 'qs'
import VConsole from 'vconsole'
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
import { BottomSheets, Cell, CellGroup, Tab, TabItem } from 'bxs-ui-vue'
import { getUrlParam } from '@/common/js/common.js'
import { enableNoSleep, disableNoSleep } from '@/pages/planbkTemplatev2/js/handler.js'
import * as WebTim from '../tim-adapter/web-tim'
import * as H5Tim from '../tim-adapter/h5-tim'
import * as WyTim from '../tim-adapter/wytim'
import * as BC from 'base/config'
import logger from '../../../base/logger'
// import { asyncStateKeys } from '../base/config'
import { getScreenSize } from '../../../common/js/dom'
import { IS_PRODUCT_ENV, INTERACTION_HOSTNAME } from 'common/utils/variables'

if (!IS_PRODUCT_ENV) {
  let vConsole = new VConsole()
  // 修复禁止滚动失效的问题，来自 [disableLogScrolling选项无效 · Issue #282 · Tencent/vConsole](https://github.com/Tencent/vConsole/issues/282)
  vConsole &&
    vConsole.pluginList &&
    (vConsole.pluginList.network.scrollToBottom = function () {
      if (!this.vConsole.option.disableLogScrolling) {
        var $box = vConsole.$.one('.vc-content')
        $box.scrollTop = $box.scrollHeight - $box.offsetHeight
      }
    })
  vConsole.setOption({ disableLogScrolling: true })
}

function formatTimer(totalSeconds, isInNaturalLang) {
  const hours = totalSeconds / 3600
  const minutes = (totalSeconds / 60) % 60
  const seconds = totalSeconds % 60
  const descArr = [hours, minutes, seconds].map((val) => Math.floor(val))
  if (isInNaturalLang) {
    const unitDescs = ['小时', '分', '秒']
    return descArr
      .map((val, idx) => (val === 0 ? '' : val + unitDescs[idx]))
      .join('')
  } else {
    return descArr.map((val) => (val < 10 ? `0${val}` : `${val}`)).join(':')
  }
}

export default {
  name: 'PresentationToolbelt',
  components: {
    [BottomSheets.name]: BottomSheets,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tab.name]: Tab,
    [TabItem.name]: TabItem,
  },
  filters: {
    formatTimer,
  },
  props: {
    isReplay: Boolean,
    isHost: Boolean,
    hostUserId: {
      type: String,
      default: null,
    },
    wechatInfo: {
      type: Object,
      default: null,
    },
    agentInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isInApp: BC.bApp,
      inWechat: BC.inWechat,
      wxMpAppid: BC.wxMpAppid,

      tim: null,
      isInRoom: false,
      isMute: false,
      memberList: [],
      elapseTime: 0,
      presenterId: '',
      bubbleText: null,

      isNeedReload: false
    }
  },
  computed: {
    audienceListCls() {
      let baseCls = 'audience-list'
      const result = [baseCls]
      if ((this.memberList || []).length > 4) {
        result.push(baseCls + '--compact')
      } else if (this.amAlone) {
        result.push(baseCls + '--alone')
      }
      return result
    },
    amAlone() {
      const { memberList } = this
      return !memberList || memberList.length < 2
    },
    aloneReminderText() {
      return this.elapseTime > 0
        ? '用户暂时离开，等待用户重新进入...'
        : '等待用户进入...'
    },
    displayMemberList() {
      const { memberList, tim, isInRoom } = this
      if (!memberList || !memberList.length || !tim || !isInRoom) {
        return []
      }
      const { userID } = tim
      const mySelf = memberList.find((member) => member.userID === userID)
      if (mySelf) {
        return [mySelf].concat(memberList.filter((member) => member !== mySelf))
      }
      return memberList
    },
  },
  watch: {
    amAlone: {
      handler(newVal) {
        this.toggleTimer(!newVal)
        if (!newVal) {
          // const size = getScreenSize()
          // this.syncPageDelta({
          //   windowWidth: size.width,
          //   windowHeight: size.height
          // })
        }
        // 讲解中劫持左上角后退按钮
        if (
          window.appBridge &&
          appBridge.checkAppFeature('REGISTER_BACK_CONTROLLER')
        ) {
          const closeReminderConf = !newVal
            ? {
                text: '您正在同屏讲解中，退出页面将结束讲解',
                okText: '确定',
                cancelText: '取消',
              }
            : false
          appBridge.registerBackController(closeReminderConf)
        }
      },
      immediate: true,
    },
    // 暂时保留抛到上级组件再回到当前组件
    // 保留 #1 方案的权限更替需要
    hostUserId: {
      handler(newVal) {
        // const { userID } = this.tim
        // TODO: #1
        // if (newVal === userID) {
        //   this.$emit('request-control', true)
        // }
        // this.presenterId = newVal
      },
    },
  },
  created() {
    this.store = { pbData: {} }
    let wechatTimer = setTimeout(() => {
      if (!this.amAlone || this.isReplay) return
      this.$messagebox({
        message: '用户还未进入讲解，您可以尝试电话联系用户，也可微信通知',
        confirmButtonText: '微信通知',
      }).then(() => {
        window.WeiyiStatSDK.submit('wxtz')
        location.href = 'wechat://'
      }).catch(() => {})
      window.WeiyiStatSDK.submit('tc')
    }, 20000)
    this.$once('hook:beforeDestroy', () => {
      clearTimeout(wechatTimer)
      wechatTimer = null
    })
  },
  mounted() {
    this.startTim()
  },
  beforeDestroy() {
    this.quit()
  },
  methods: {
    async startTim () {
      const { RESULT_VERSION, agentInfo, wechatInfo, isReplay, isInApp, inWechat, wxMpAppid : appId } = this
      const TimAdapter = isReplay ? WyTim : isInApp ? WebTim : H5Tim
      const interactionType = RESULT_VERSION && RESULT_VERSION === 2 ? 4 : undefined
      try {
        if (isReplay || isInApp) {
          const { photo, name = '未知用户', userUuid} = agentInfo
          this.tim = await TimAdapter.initTim(photo, name, userUuid, interactionType)
        } else {
          const roomId = getUrlParam('roomId')
          const { tobAppId } = agentInfo
          const { avatar, name = '未知用户', nickname, pbUuid, salesUuid, token } = wechatInfo
          const initParams = {
            avatar,
            nick: nickname || name,
            token,
            appId,
            pbUuid,
            salesUuid,
            roomId,
            tobAppId,
            interactionType
          }

          if (!inWechat) {
            this.$toast('同屏讲解功能，请在微信下使用')
            return
          }
          // console.error('测试用，上线请删除！')
          // const wxname = getUrlParam('wxname')
          // const debugObj = {
          //   kewang: {
          //     avatar: 'https://img.zcool.cn/community/01r3gm1gof6jwiuhsyarhw3235.jpg?x-oss-process=image/auto-orient,1/resize,m_lfit,w_1280,limit_1/sharpen,100/format,webp/quality,q_100',
          //     token: '1b0dce2e-7b21-c5e0-4f93-6fcf47d093f9'
          //   },
          //   lizhao: {
          //     avatar: 'https://thirdwx.qlogo.cn/mmopen/vi_32/Q0j4TwGTfTJQehbL0L38YTKbv1dqMbzV0jySCRNztsyLRGIUp4Y475DHp03WKnzMe5b3hpcBKmvYhjZlMBvicGA/132',
          //     token: '0bbadf66-5cd4-9268-9a63-f0af76cdfaca'
          //   }
          // }
          // const debugData = debugObj[wxname]
          // if (debugData) {
          //   for(const k in debugData) {
          //     initParams[k] = debugData[k]
          //   }
          // }

          this.tim = await TimAdapter.initTim(initParams)
        }
        const tim = this.tim
        if (!tim) {
          return
        }

        this.bindTimListener()
        // 同屏讲解回放
        if (isReplay) {
          this.$emit('tim-ready', tim)
        } else {
          this.$emit('enter-success')
        }

        await this.pullMemberList()
        if (this.memberList.length === 1) {
          // TODO: #1
          // 先进获得控制权
          // this.$emit('request-control', true)
          // this.$emit('request-host-id', tim.userID)
          window.WeiyiStatSDK.submit('waiting')
        } else {
          // TODO: #1
          // 后进无控制权
          // this.$emit('request-control', false)
          // this.$emit('request-host-id', 'true')
          const size = getScreenSize()
          this.syncPageDelta({
            windowHeight: size.height,
            windowWidth: size.width,
          })
        }
        this.isInRoom = true

        logger.warn('[TOOLBELT]', '准备开启语音')
        await tim.startAudioChat((trtcMessage) => {
          // msg = {type:'error'|'warning'|'info', code:int, msg:string, info:{}}
          // TODO: TRTC error 需要进一步处理，如开启失败时提示
          const { msg } = trtcMessage
          this.showBubbleMessage(msg)
        })
        this.unload()
      } catch (e) {
        console.warn('[TOOLBELT]', '初始化失败', e)
        const MESSAGE_OBJ = {
          INVALID_ROOMID: '讲解链接已失效，请联系客户并重新分享同屏讲解',
          APP_VERSION_NOT_SUPPORT_TRTC: '您的 App 版本过低不支持实时语音。建议联系客户，升级 App 后重新分享同屏讲解。',
          DEFAULT: `建立同屏讲解连接时遇到了一点问题：${e.message}`
        }
        const type = ['INVALID_ROOMID'].includes(e.message) ? 'dialog' : 'alert'
        const msg = MESSAGE_OBJ[e.message] || MESSAGE_OBJ.DEFAULT
        this.$messagebox[type](msg).then(() => {
          window.WeiyiStatSDK.submit('tips', {
            title: '进房失败',
          })
        })
        return
      }
    },
    async pullMemberList() {
      const { tim, isReplay } = this
      if (!tim || isReplay) {
        return
      }
      this.memberList = await tim.getGroupMemberList()
    },
    directMemberList(list) {
      if (!list || !Array.isArray(list)) return
      const { memberList } = this
      const isOut = memberList.length > list.length
      const action = isOut ? '退出' : '进入'
      const changeBase = isOut ? [memberList, list] : [list, memberList]
      const changeList = changeBase[0].filter(
        (user) => !changeBase[1].find((mb) => mb.userID === user.userID)
      )
      const userNicks = changeList.map((user) => user.nick)
      this.showBubbleMessage(`用户${userNicks.join('、') + action}了讲解`)
      this.memberList = list
    },
    bindTimListener() {
      const { tim } = this
      if (!tim) {
        return
      }
      const onPeerQuitOrGroupDismiss = () => {
        this.$messagebox
          .alert('用户已经离开，您可以再次联系他进入讲解')
          .then(() => {
            window.WeiyiStatSDK.submit('tips', {
              title: '客户退出',
            })
            if (appBridge && appBridge.checkAppFeature('CLOSE_VIEW')) {
              appBridge.closeView()
            }
          })
        this.quitPresentation()
      }
      tim.on(tim.EVENTS.onJoinGroup, async (payload) => {
        const changeList = payload.userIDList.filter((id) => id !== tim.userID)
        if (changeList.length === 0) {
          return
        }
        tim.getUserProfile(changeList).then((res) => {
          if (!res) return
          const userNicks = res.data.map((user) => user.nick)
          this.showBubbleMessage(`用户${userNicks.join('、')}进入了讲解`)
          logger.warn(
            `[TOOLBELT]', '用户${userNicks.join('、')}加入了讲解，列表更新`
          )
        })
        await this.pullMemberList()
        // TODO: #1
        // 主控
        // if (this.isHost) {
        //   this.gainPresenterControl()
        // }
      })
      tim.on(tim.EVENTS.onQuitGroup, async (payload) => {
        // 再次进入会收到上次自己退出的消息
        const changeList = payload.userIDList.filter((id) => id !== tim.userID)
        if (changeList.length === 0) {
          return
        }
        tim.getUserProfile(changeList).then((res) => {
          if (!res) return
          const userNicks = res.data.map((user) => user.nick)
          this.showBubbleMessage(`用户${userNicks.join('、')}退出了讲解`)
          window.WeiyiStatSDK.submit('tips', {
            title: '客户退出',
          })
          logger.warn(
            `[TOOLBELT]', '用户${userNicks.join('、')}退出了讲解，列表更新`
          )
        })
        await this.pullMemberList()
        // TODO: #1
        // 只剩自己-获得控制权
        // if (this.memberList.length === 1 && !this.isHost) {
        //   this.$emit('request-control', true)
        // }
      })
      tim.on(tim.EVENTS.onGroupMessageReceived, (message) => {
        const payload = message.payload
        try {
          const { extendMsgType, contentBody } = JSON.parse(payload.text)
          if (!this.isHost && extendMsgType === 'PAGE_SYNC') {
            this.$emit('page-sync', contentBody)
          } else if (extendMsgType === 'PRE_PAGE_SYNC') {
            this.$emit('pre-page-sync', contentBody)
          }
        } catch (e) {
          logger.warn('[TOOLBELT]', 'TIMTextElem 消息异常')
        }
      })
      tim.on(tim.EVENTS.onDismissGroup, (payload) => {
        logger.warn('[TOOLBELT] 散群消息导致退群')
        onPeerQuitOrGroupDismiss()
      })
      tim.on(tim.EVENTS.onDefinedField, (payload) => {
        const { mType, contentBody } = payload
        if (mType === 31) {
          const newHost = contentBody === tim.userID
          this.$emit('request-control', newHost)
          this.$emit('request-host-id', contentBody)
          this.gainPresenterControl(newHost)
          console.log('系统自定义消息，控制权转移', contentBody)
        }
        // 成员信息
        if (mType === 32) {
          this.directMemberList(contentBody)
        }
      })
    },
    showBubbleMessage(msg) {
      if (this.bubbleTimer) {
        clearTimeout(this.bubbleTimer)
        this.bubbleTimer = null
      }
      this.bubbleText = msg
      this.bubbleTimer = setTimeout(() => {
        this.bubbleText = null
        this.bubbleTimer = null
      }, 2500)
    },
    confirmToQuit() {
      this.$messagebox
        .dialog('是否要退出讲解？', {
          cancelButtonText: '是',
          confirmButtonText: '否',
        })
        .then(() => {
          window.WeiyiStatSDK.submit('tips', {
            title: '退出取消',
          })
        })
        .catch(() => {
          this.$messagebox.alert(
            `本次用时${formatTimer(this.elapseTime, true)}`,
            '实时讲解已停止',
            {
              cancelButtonText: '确定',
              cancelButtonColor: '#0A64FE',
            }
          )
          window.WeiyiStatSDK.submit('tips', {
            title: '退出确定',
          })
          window.WeiyiStatSDK.submit('quit')
          this.quitPresentation(true)
          if (appBridge && appBridge.checkAppFeature('CLOSE_VIEW')) {
            appBridge.closeView()
          }
        })
    },
    quitPresentation(isEndInvalidateRoom = false) {
      if (this.tim) {
        this.tim.quitPresentation(isEndInvalidateRoom)
        this.tim.instance.destroy()
      }
      this.isInRoom = false
      this.toggleTimer(false)
      this.$emit('quit-presentation')
    },
    syncDelta(delta) {
      if (this.isHost && this.tim) {
        this.tim.sendMessage({
          extendMsgType: 'PAGE_SYNC',
          contentBody: delta,
        })
        this.updateStore(delta)
      }
    },
    syncPageDelta(delta, directly) {
      if (directly || (this.isHost && this.tim)) {
        logger.warn('[rePage] 发送消息：', delta)
        this.tim.sendMessage({
          extendMsgType: 'PRE_PAGE_SYNC',
          contentBody: delta,
        })
      }
    },
    requestPresenterControl() {
      if (!this.isHost && this.tim) {
        this.tim.requestPresenterControl()
      }
      // TODO: #1
      // this.gainPresenterControl()
    },
    gainPresenterControl(isHost) {
      const size = getScreenSize()
      this.syncPageDelta(
        {
          windowWidth: size.width,
          windowHeight: size.height,
        },
        isHost
      )
      // TODO: #1
      // !this.isHost && this.$emit('request-control', true)
      // this.$emit('request-host-id', this.tim.userID)
      this.$emit('synchronous-history', this.store)
    },
    updateStore(delta) {
      // const { store } = this
      // , pbData, boardData
      const { top } = delta
      if (top !== undefined) {
        this.store.top = top
      }
      // if (boardData !== undefined) {
      //   if (Array.isArray(store.boardData)) {
      //     this.store.boardData.push(boardData)
      //   } else {
      //     this.store.boardData = boardData
      //   }
      // }
      // if (pbData !== undefined) {
      //   asyncStateKeys.forEach(key => {
      //     if (pbData[key] !== undefined) {
      //       this.store.pbData[key] = pbData[key]
      //     }
      //   })
      // }

      // const { actions, baselineTime } = this
      // actions.push({
      //   delay: timestamp - baselineTime,
      //   delta
      // })
      // console.log('actions', JSON.stringify(this.actions))
    },
    toggleTimer(isOn) {
      const needChange = !!this.elapseTimeTimer !== isOn
      if (!needChange) {
        return
      }
      if (this.elapseTimeTimer) {
        window.clearInterval(this.elapseTimeTimer)
        this.elapseTimeTimer = null
      }
      const isElapse = this.memberList.length < 2
      if (isOn) {
        if (isElapse) return
        this.elapseTimeTimer = window.setInterval(() => {
          this.elapseTime += 1
        }, 1000)
        enableNoSleep()
        window.WeiyiStatSDK.submit('begin')
      } else {
        if (isElapse) {
          this.elapseTime = 0
        }
        window.WeiyiStatSDK.submit('end', {
          time_length: this.elapseTime,
        })
      }
    },

    quit () {
      const { tim, quitPresentation } = this
      if (tim) {
        logger.warn('[TOOLBELT]', 'beforeDestroy 生命周期钩子触发退房')
        quitPresentation(true)
        disableNoSleep()
      }
      this.toggleTimer(false)
    },
    unload () {
      const self = this
      const { isInApp, quitPresentation } = self
      if (isInApp) {
        if (window.appBridge && appBridge.checkAppFeature('REGION_PICKER')) {
          window.unload = () => {
            logger.warn('[TOOLBELT]', 'bridge unload 钩子触发退房')
            quitPresentation()
          }
        }
        return
      }

      const eventNames = ['beforeunload', 'unload', 'pagehide', 'visibilitychange']
      eventNames.forEach(n => {
        (n === 'visibilitychange' ? document : window).addEventListener(n, () => {
          if (self.isNeedReload) {
            return
          }
          if (n === 'visibilitychange' && document.visibilityState !== "hidden") {
            return
          }
          if ('sendBeacon' in navigator) {
            const {pbUuid, salesUuid, clientUuid, roomId} = self.tim.pageContext
            const urlParamsStr = QS.stringify({
              pbUuid,
              salesUuid,
              clientUuid,
              groupId: roomId
            })
            navigator.sendBeacon(`${INTERACTION_HOSTNAME}/interactionCommon/endInteractionByClientFormData`, urlParamsStr)
          }
          quitPresentation(true)
          self.isNeedReload = true
        })
      })

      const eventNames2 = ['pageshow', 'visibilitychange']
      eventNames2.forEach(n => {
        (n === 'visibilitychange' ? document : window).addEventListener(n, () => {
          if (!self.isNeedReload) {
            return
          }
          if (n === 'visibilitychange' && document.visibilityState !== "visible") {
            return
          }
          self.isNeedReload = false
          location.reload()
        })
      })
    }
  },
}
</script>
<style lang="postcss">
.invite-presentation-btn {
  position: fixed;
  right: 15px;
  bottom: 70px;
  width: 56px;
  height: 56px;
  border-radius: 28px;
  background-color: var(--primary-color);
  text-align: center;
  padding: 12px 14px;
  color: #fff;
  font-size: 13px;
  line-height: 16px;
  font-weight: 600;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);
}

.presentation-toolbelt {
  z-index: 100;
  position: fixed;
  display: flex;
  align-items: center;
  bottom: 40px;
  left: 15px;
  right: 15px;
  height: 58px;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 8px;
  padding: 9px;
  color: #fff;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: constant(safe-area-inset-bottom);
  margin-bottom: env(safe-area-inset-bottom);

  & .audience-list {
    flex-grow: 1;
    display: flex;
  }

  & .audience-list--compact span:nth-child(n + 2) {
    margin-left: -4px;
  }

  & .audience-list--alone {
    flex-grow: initial;
  }

  & .waiting-reminder {
    margin-left: 15px;
    font-size: 13px;
    line-height: 16px;
    font-weight: bold;
  }

  & .member-avatar {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background-size: 100% auto;
    background-position: center;
    background-repeat: no-repeat;
    background-color: aliceblue;
  }

  & .member-avatar-presenter::before {
    content: '';
    position: absolute;
    left: 0;
    top: 4px;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background-color: #ff0000;
  }

  & .request-control-btn {
    line-height: 40px;
  }

  & .timer-and-end-btn {
    margin-left: 9px;
    text-align: center;
    height: 40px;
    padding: 7px 10px;
    background: #f90;
    border-radius: 20px;
    font: inherit;

    & .timer {
      margin-top: 3px;
    }
  }

  & .message-bubble {
    box-sizing: border-box;
    position: absolute;
    left: -3px;
    bottom: 57px;

    & .bubble-text {
      box-sizing: border-box;
      max-width: 375px;
      height: 24px;
      background-color: #dae8ff;
      border-radius: 8px 8px 8px 0px;
      padding: 6px 9px;
      overflow: hidden;
      font-size: 11px;
      font-weight: bold;
      color: var(--primary-color);
      line-height: 12px;
    }

    & .bubble-tip {
      box-sizing: border-box;
      width: 0;
      height: 0;
      border-style: solid;
      border-width: 8px 5px 0 0;
      border-color: #dae8ff transparent transparent transparent;
    }
  }
}
</style>
